//basic
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

//style
import './index.scss'

//api
import { api } from '../../../../functions/api'

//custom components
import CustomButton from '../../../../components/basic/CustomButton'
import CustomTable from '../../../../components/complex/customTable'

//material-ui
import { CircularProgress } from '@material-ui/core'

//other libraries
import queryString from 'query-string'
import Icon from '@mdi/react'
import { mdiCamera } from '@mdi/js'
import ScanProduct from './scanProduct'
import { toJS } from 'mobx'

@inject('internal')
@inject('translate')
@observer
export default class IssueCardProducts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingPage: true,
      loadingTable: true,
      scanProduct: false,
    }
  }
  
  componentDidMount() {
    this.loadProducts()
  }
  
  tableReload = false
  
  tableHeader = [
    {
      title: 'product',
    },
    {
      title: 'ean',
    },
    {
      title: 'pieces',
      numeric: true,
    },
    {
      title: 'pieces_loaded',
      numeric: true,
    },
    {
      title: 'warehouse_location',
      numeric: true,
      align: 'right'
    },
  ]
  tableBody = [
    'issue_card_product_name',
    'code',
    'pieces',
    'pieces_loaded',
    'warehouse_location',
  ]
  
  dropDownMenuItems = []
  
  addQueryToUrl = (param, value, param2 = null, value2 = null) => {
    this.tableReload = true
    
    const URLqueryString = this.props.routerData.history.location.search
    let queries = queryString.parse(URLqueryString)
    queries[param] = value
    if (param2 && value2) {
      queries[param2] = value2
    }
    
    let new_path = this.props.routerData.location.pathname
    
    new_path += '?'
    for (let key in queries) {
      if (key) {
        new_path += key + '=' + queries[key] + '&'
      }
    }
    new_path = new_path.slice(0, -1)
    
    this.props.internal.pushRoute(new_path)
    this.loadProducts()
  }
  
  loadProducts = async () => {
    if (this.tableReload) {
      this.setState({ loadingTable: true })
    }
    
    let id = this.props.routerData.match.params.id
    
    let load_data = await api({
      method: 'get',
      url: `issue-cards/${id}/products`,
      authorization: this.props.internal.user.access_token,
    })
    
    
    if (load_data.success === true) {
      if (load_data.data) {
        this.props.internal.setDataForTable(load_data.data)
        this.setState({ loadingTable: false })
      }
    }
    this.setState({ loadingPage: false })
    
    if (this.tableReload) {
      this.setState({ loadingTable: false })
      this.tableReload = false
    }
  }
  
  toggleScanProduct = () => {
    this.setState({ scanProduct: ! this.state.scanProduct })
  }
  
  handleAfterSave = () => {
    this.toggleScanProduct()
    this.loadProducts()
    this.props.handleAfterSave(false)
  }
  
  render() {
    if (this.state.loadingPage) {
      <CircularProgress className={'circular-progress'}/>
    }
    
    const icId = this.props.routerData.match.params.id
    const permissions = toJS(this.props.internal.user.data.permissions)
    
    return (
      <div className={'tech-docs'}>
        <ScanProduct
          open={this.state.scanProduct}
          onClose={this.toggleScanProduct}
          issueCardId={icId}
          handleAfterSave={this.handleAfterSave}
        />
        <div className={'flex space-between mb-first-line'}>
          <span/>
          {permissions.issue_cards.take_out ? (
            <CustomButton
              mystyle={'btn-orange-bg border-radius-18'}
              title={this.props.translate.i18n.MODULES.ISSUE_CARDS.SCAN_PRODUCT}
              onClick={this.toggleScanProduct}
              justText
            >
              <Icon path={mdiCamera} size={1}/>
            </CustomButton>
          ) : null}
        </div>
        {this.state.loadingTable
          ?
          <CircularProgress className={'circular-progress'}/>
          :
          // null
          <CustomTable
            dropDownMenuItems={this.dropDownMenuItems}
            module={'/issue_cards'}
            header={this.tableHeader}
            body={this.tableBody}
            disablePagination={true}
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/detail/products/index.jsx